import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/constants";

export default function WhatsappFab() {
    const link = `https://wa.me/${BRAND.whatsappRaw}?text=${encodeURIComponent(
        "Hola Ariadna, vengo desde tu sitio web."
    )}`;
    return (
        <a
            href={link}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-fab"
            aria-label="Escribir por WhatsApp"
            className="fixed bottom-20 right-5 z-40 group flex items-center gap-3 px-5 py-3.5 bg-[#1E1E1E] text-[#F7F3EE] rounded-full shadow-[0_20px_50px_-15px_rgba(30,30,30,0.6)] hover:bg-[#C6A76A] hover:text-[#1E1E1E] transition-all duration-400 hover:-translate-y-1"
        >
            <MessageCircle size={18} strokeWidth={1.5} />
            <span className="hidden sm:inline text-[11px] tracking-[0.2em] uppercase font-medium">
                WhatsApp
            </span>
        </a>
    );
}
